import React from "react";

/**
 * component svg 
 */
const NoProfileImage = function (props) {

    return (
        <svg version="1.1" id="no-profile-image" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	    viewBox="0 0 1000 1000">
            <g>
                <circle class="st0-npi" cx="500" cy="272.4" r="228.4"/>
                <path class="st0-npi" d="M873,956c37.3,0,66.2-33.3,60.3-70.5C904.9,700.4,764.6,507.5,500,507.5S95,700.2,66.6,885.3
                    c-5.5,36.9,22.9,70.5,60.3,70.5L873,956L873,956z"/>
            </g>
        </svg>
    );
};

export default NoProfileImage;